module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0045.jpg?v=66a3ee65";